<template>
  <div>
    <NuxtLayout>
      <BaseThemeProvider brand-code="topics">
        <StoryblokComponent v-if="storyData?.data.story" :blok="storyData.data.story.content" />
      </BaseThemeProvider>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
  import '@/assets/css/topics.css';
  import type { ISbStory } from 'storyblok-js-client';
  useRouter().listening = false;

  useTopicsGtm('GTM-KDQ73J6R');

  provide('topicsCountry', 'be');

  const integratorId = 'topics-be';
  useHead({
    link: [
      {
        rel: 'preconnect',
        href: `https://myprivacy-static.dpgmedia.net`,
      },
    ],
    script: [
      {
        key: '_privacy',
        type: 'text/javascript',
        innerHTML: `
            window._privacy = window._privacy || [];
            window.cmpProperties = { baseUrl: '${integratorId}', cmpCname: 'https://cmp.topics.be', language: 'nl' };
          `,
      },
      {
        tagPriority: 'after:script:cmpProperties',
        key: 'privacyGate',
        src: 'https://myprivacy-static.dpgmedia.net/consent.js',
        async: true,
      },
    ],
  });

  const storyData = useState<ISbStory<MarketingTopicsPageStoryblok> | undefined>('storyDataBE', () => undefined);
  await callOnce(async () => {
    const { data } = await useStoryFetch<MarketingTopicsPageStoryblok>({
      path: `/marketing-pages/topics-be`,
      params: {
        resolve_relations: ['MarketingFaqsBlok.faqs'],
      },
    });
    storyData.value = data.value;
  });
</script>
